import { IdentityProvider, isScimEnabled } from "../../../../domain/IdentityProvider";
import { Button, Disclose, Typography } from "@optimizely/axiom";
import React from "react";

export const DomainsDisclosure = ({
    identityProvider,
    onEdit
}: {
    identityProvider: IdentityProvider;
    onEdit: () => void;
}) => {
    const { domains = [] } = identityProvider;
    // When SCIM is enabled, provisioning is owned by the IdP — editing domains here would
    // conflict with SCIM provisioning, so the edit action is disabled.
    const scimManaged = isScimEnabled(identityProvider);
    return (
        <Disclose title={identityProvider.idpName}>
            <div className="flex flex--column push-triple--left">
                <Typography type="caption">Domains</Typography>
                <Typography type="xs">
                    <span style={{ color: "#707070" }}>{domains?.join(", ")}</span>
                </Typography>
                {scimManaged && (
                    <Typography type="xs" className="push--top" data-testid="scim-domains-disabled-note">
                        <em>Domains are managed by SCIM provisioning and can&apos;t be edited here.</em>
                    </Typography>
                )}
                {/* eslint-disable-next-line react/style-prop-object */}
                <Button
                    className="push-triple--top min-width--150 max-width--150"
                    style="outline"
                    onClick={onEdit}
                    isDisabled={scimManaged}
                >
                    Edit Domains
                </Button>
            </div>
        </Disclose>
    );
};

DomainsDisclosure.displayName = "DomainsDisclosure";
